import React from 'react';
import styled from 'styled-components';

const PricingPage = () => {
  return (
    <Container>
      <Title>Under Construction</Title>
      <Message>We are working hard to bring you the best pricing plans. Stay tuned for updates!</Message>
    </Container>
  );
};

export default PricingPage;

const Container = styled.div`
  padding: 20px;
  background-color: #f8f9fa;
  text-align: center;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const Title = styled.h1`
  font-size: 36px;
  color: #343a40;
  margin-bottom: 20px;
`;

const Message = styled.p`
  font-size: 24px;
  color: #6c757d;
`;
